import Inventory from '../pages/Inventory';
export default Inventory; 